<div class="container-fluid pt-3">
    <div class="">
        <div class="col-sm-6 pb-3" [ngClass]="
                this.updatedtheme === 'dark' ? 'headlinetextD' : 'headlinetextL'
            ">
            <h3 class="pl-3">Company Profile</h3>
        </div>

        <br />
        <div class="row" [ngClass]="this.updatedtheme === 'dark' ? 'main-boxD' : 'main-boxL'">
            <div class="col-6">
                <div class="ct_company_profile_input">
                    <label for="companyName" class="mt-4">Company Name</label>
                    <input type="text" [(ngModel)]="companyDetails.companyName" name="companyName" placeholder="Enter Company Name" [ngClass]="
                            this.updatedtheme === 'dark'
                                ? 'inputboxD'
                                : 'inputboxL'
                        " />
                </div>

                <div class="ct_company_profile_input">
                    <label for="industryType" class="mt-3 mb-2">Industry Type</label>
                    <div class="">
                        <p-dropdown class="ct_select_op_input ct_flex_1 ct_chev_icon_dark230 " defaultLabel="Select Industry Type" [options]="category" placeholder="Please select"
                            [(ngModel)]="selectedIndustryTypes" optionLabel="category" name="industryType" (onChange)="onIndustryTypeChange($event)"   optionValue="category"></p-dropdown>
                    </div>
                </div>

                <div class="ct_company_profile_input">
                    <label for="secondaryIndustryType" class="mt-3 mb-2 w-100">Secondary Industry Type</label>
                    <p-multiSelect class="ct_select_2_full_width12 ct_input_dark_text_145" placeholder="Please select" [options]="industryTypes" [(ngModel)]="selectedSecondaryIndustryTypes" [ngModelOptions]="{standalone: true}"   optionValue="sub_category"
                        optionLabel="sub_category" display="chip"
                        name="sub_category"></p-multiSelect>
                </div>

                <div class="ct_company_profile_input">
                    <label for="location" class="mt-3">Country</label>
                        <p-dropdown
                        class="ct_select_op_input ct_chev_icon_dark230"
                        ngModel [options]="countries" optionLabel="name" [(ngModel)]="selectedCountry"
                        optionValue="name"  name="country"
                        #unitSet="ngModel" [filter]="true" filterBy="name"
                        [showClear]="true" placeholder="Select country">
                        <ng-template pTemplate="selectedItem">
                            <div class="country-item country-item-value" *ngIf="selectedCountry">
                                <div>{{selectedCountry}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="country-item">
                                <div>{{country.name}}</div>
                            </div>
                        </ng-template></p-dropdown>
                </div>

                <div class="row mt-5">
                    <button  type="submit" class="px-3 ct_animation_btn_121" (click)="saveChanges()">
                        Save Changes
                    </button>
                </div>
            </div>

           
            <div class="col-6">
                <div class="mr-3 ml-5">
                    <label for="logo" class="mt-4 mb-1">Logo</label>
                    <p style="font-size: 16px" class="mt-0">
                        We suggest you upload a transparent PNG logo with a size
                        of 140px width and 50px height.
                    </p>
                </div>
               
                <div class="d-flex ml-5">
                    <div class="uploadfile-div d-flex align-items-center">
                        <input type="file" class="fileinput pointer" (change)="onFileSelected($event)"
                            accept=".jpg,.png" />
                    </div>
                   
                    <div class="logodiv d-flex align-items-center justify-content-center" style="    height: 200px;
                    width: 100%;">
                        <p-image [src]="uploadedImageUrl" alt="Image" height="100" width="150"></p-image>
                    </div>

                   
                </div>

                <div class="mr-2 ml-5">
                    <div class="mt-3">
                        <label for="bio">Brief</label>
                    </div>
                    <div class="ct_company_profile_input">
                        <textarea [ngModel]="companyDetails.companyBio === 'null' ? '' : companyDetails.companyBio" class="textarea" pInputTextarea
                            [autoResize]="true" name="bio"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>